import type { BehaviorDocument } from "../types";
import { createNodeId } from "../types";

export const SPOT_WALK_TEMPLATE_ID = "builtin_spot_walk_v1";

export function createSpotWalkTemplate(): BehaviorDocument {
  const nRoot = createNodeId();
  const nWalk = createNodeId();
  return {
    id: SPOT_WALK_TEMPLATE_ID,
    name: "Spot Walk (template)",
    isTemplate: true,
    baselineSnapshot: null,
    rootId: nRoot,
    nodes: {
      [nRoot]: {
        id: nRoot,
        kind: "sequence",
        label: "Spot walk flow",
        children: [nWalk],
      },
      [nWalk]: {
        id: nWalk,
        kind: "runTrainedModel",
        label: "Spot Walk",
        modelId: "spot-walk-locomotion",
        durationSeconds: 6,
        commandVx: 0.25,
        commandWz: 0,
      },
    },
  };
}
